/* generated using openapi-typescript-codegen -- do not edit */
/* istanbul ignore file */
/* tslint:disable */
/* eslint-disable */
export enum PayrollCycle {
  WEEKLY = 'WEEKLY',
  WEEKLY_DEDUCTIONS = 'WEEKLY_DEDUCTIONS',
  BIWEEKLY = 'BIWEEKLY',
  BIWEEKLY_DEDUCTIONS = 'BIWEEKLY_DEDUCTIONS',
  MONTHLY = 'MONTHLY',
  SEMI_MONTHLY = 'SEMI_MONTHLY',
}
